module.exports = __webpack_public_path__ + "static/media/490.c86005ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/cursos/490.jpg
// module id = 145
// module chunks = 0